mutation UpdateMetadataField($fieldId: ID!, $name: String!) {
    updateMetadataField(fieldId: $fieldId, name: $name) {
        _id
        name
    }
}
